import React from "react";
import { useAuthUser } from "react-auth-kit";
import { Navigate, Outlet } from "react-router-dom";

const RequireAdmin = () => {
  const user = useAuthUser();
  return user().data?.roles?.[0].id === 4 ? <Outlet/> : <Navigate to="/forbidden"/>;
};

export default RequireAdmin;